import api from './api';

export interface Category {
  _id?: string;
  name: string;
  description?: string;
  color: string;
  icon?: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const categoryService = {
  // Get all categories
  getCategories: async (isActive?: boolean): Promise<{ categories: Category[] }> => {
    const params = isActive !== undefined ? { isActive } : {};
    const response = await api.get('/categories', { params });
    return response.data;
  },

  // Get a single category by ID
  getCategoryById: async (categoryId: string): Promise<{ category: Category }> => {
    const response = await api.get(`/categories/${categoryId}`);
    return response.data;
  },

  // Create a new category
  createCategory: async (categoryData: Omit<Category, '_id' | 'createdAt' | 'updatedAt'>) => {
    const response = await api.post('/categories', categoryData);
    return response.data;
  },

  // Update a category
  updateCategory: async (categoryId: string, categoryData: Partial<Category>) => {
    const response = await api.put(`/categories/${categoryId}`, categoryData);
    return response.data;
  },

  // Delete a category
  deleteCategory: async (categoryId: string) => {
    const response = await api.delete(`/categories/${categoryId}`);
    return response.data;
  }
};

export default categoryService;
